import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ViewContracts: React.FC = () => {
    const [contracts, setContracts] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchContracts();
    }, []);

    const fetchContracts = async () => {
        setIsLoading(true);
        setError('');
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Contracts`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setContracts(response.data);
        } catch (error: any) {
            setError('Failed to load contracts.');
        } finally {
            setIsLoading(false);
        }
    };

    const deleteContract = async (id: number) => {
        if (!window.confirm('Are you sure you want to delete this contract? This action cannot be undone.')) return;
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Contracts/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setContracts(contracts.filter(contract => contract.id !== id));
            alert('Contract deleted successfully!');
        } catch (error: any) {
            console.error('Failed to delete contract:', error);
            if (error.response && error.response.status === 404) {
                setError('Contract not found or you do not have permission to delete it.');
            } else {
                setError('Failed to delete contract. Please try again.');
            }
        }
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4 text-center">Your Contracts</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            {isLoading && <div className="alert alert-info">Loading...</div>}
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">Contracts ({contracts.length})</h4>
                        </div>
                        <div className="card-body">
                            {contracts.length === 0 && !isLoading && !error ? (
                                <p className="text-muted text-center">No contracts created yet.</p>
                            ) : (
                                <ul className="list-group list-group-flush">
                                    {contracts.map((contract) => (
                                        <li
                                            key={contract.id}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                        >
                                            <div>
                                                {contract.name || `Contract ${contract.id}`}
                                                <small className="d-block text-muted">
                                                    Status: {contract.status}
                                                </small>
                                                <small className="d-block text-muted">
                                                    Signed: {contract.hasSignature ? 'Yes' : 'No'}
                                                </small>
                                            </div>
                                            <div>
                                                <Link
                                                    to={`/contract-details/${contract.id}`}
                                                    className="btn btn-outline-primary btn-sm me-2"
                                                >
                                                    View Details
                                                </Link>
                                                <button
                                                    onClick={() => deleteContract(contract.id)}
                                                    className="btn btn-danger btn-sm"
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewContracts;